import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as stAPI from '../../lib/api/stapi';
import { takeLatest } from 'redux-saga/effects';

// [START] API 서버에 Request ------------------------->

const [
    ST_FILTER,
    ST_FILTER_SUCCESS,
    ST_FILTER_FAILURE,
] = createRequestActionTypes('sp/ST_FILTER');

// const ST_DEL_FILTER = createRequestActionTypes('sp/ST_DEL_FILTER');

export const reqStFilterAction = createAction(ST_FILTER);
// export const setStDelFilterAction = createAction(ST_DEL_FILTER);
/**
 * SAGA API 에서 REST API 호출 
 */
const listStFilterSaga = createRequestSaga(ST_FILTER, stAPI.getFilters);
export function* stFilterSaga() {
    yield takeLatest(ST_FILTER, listStFilterSaga);
}
// [END] API 서버에 Request ------------------------------>

/**
 * Store에 저장될 값 
 */
const initialState = {
    stFilterInfo: null,
    stItems: null,
    error: null,
    // stDelFilterInfo: null
}

const stFilterReducer = handleActions(
    {
        [ST_FILTER]: (state) => ({
            ...state,
            stFilterInfo: null,
            stItems: null,
            error: null,
            // stDelFilterInfo: null
        }),
        [ST_FILTER_SUCCESS]: (state, { payload: stFilterInfo }) => ({
            ...state,
            stFilterInfo,
            error: null,
        }),
        [ST_FILTER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            stFilterInfo: null,
            stItems: null,
            error,
        }),
        // [ST_DEL_FILTER]: (state, { payload: stDelFilterInfo }) => ({
        //     ...state,
        //     stDelFilterInfo: stDelFilterInfo
        // })
    }
    , initialState);

export default stFilterReducer;
